import React from "react";
import { Link } from "react-router-dom";

import { Stack, Text } from "@/components/ui";
import { config } from "@/utils/config";
import { openCookiePreferences, openDoNotSellModal } from "@/utils/osano";

const linkClass = "text-primary-600 hover:underline dark:text-primary-400";

const Footer = () => {
  const navlinks = config.navlinks.homeFooter;

  return (
    <Stack alignItems="center">
      <div className="flex flex-row flex-wrap items-center justify-center gap-6">
        {navlinks.map((link, idx) => {
          const url = link.url;
          const isExternal = url.startsWith("http");
          const Comp = (isExternal ? "a" : Link) as "a";
          const compProps = isExternal
            ? { href: url, target: "_blank" }
            : { to: url };
          return (
            <div key={idx}>
              <Comp {...compProps} className={linkClass}>
                <Text tag="span" weight="medium" theme="inherit" size="sm">
                  {link.title}
                </Text>
              </Comp>
            </div>
          );
        })}
        <div>
          <button
            type="button"
            onClick={openCookiePreferences}
            className={linkClass}
          >
            <Text tag="span" weight="medium" theme="inherit" size="sm">
              Cookie Preferences
            </Text>
          </button>
        </div>
        <div>
          <button
            type="button"
            onClick={openDoNotSellModal}
            className={linkClass}
          >
            <Text tag="span" weight="medium" theme="inherit" size="sm">
              Do Not Sell or Share My Personal Information
            </Text>
          </button>
        </div>
      </div>

      <Text theme="muted" align="center" size="sm" className="pt-10 lg:pt-2">
        ©{new Date().getFullYear()} Truth Social
      </Text>
    </Stack>
  );
};

export default Footer;
